import { Text } from "@puzzle/ui";
import { styled, vars } from "@puzzle/theme";

export const StyledPayrollTable = styled("table", {
  border: "1px solid $outline-neutral-subdue",
  borderCollapse: "collapse",
  width: "100%",

  th: {
    border: "1px solid $outline-neutral-subdue",
  },

  td: {
    fontSize: "$body",
    letterSpacing: "bodyXS",
    lineHeight: "$headingS",
  },
});

export const TR = styled("tr", {
  variants: {
    isLastOfGroup: {
      true: {
        td: {
          borderBottom: "1px solid $outline-neutral-moreSubdue",
        },
      },
      false: {},
    },

    bold: {
      true: {
        td: {
          color: "$text-neutral-moreHighlight",
          fontWeight: "$heavy",
        },
      },
      false: {},
    },

    variant: {
      subheader: {
        th: {
          fontSize: "$body",
          letterSpacing: "0.2px",
          lineHeight: "$headingS",
          fontWeight: "$normal",
          borderBottom: "1px solid $outline-neutral-moreSubdue",
          backgroundColor: "$surface-neutral-base",
        },
      },
    },
  },
});

export const TH = styled("th", {
  backgroundColor: "$surface-neutral-base",
  color: "$text-neutral-base",
  fontSize: "$bodyXS",
  lineHeight: "14px",
  fontWeight: "$bold",
  letterSpacing: "0.5px",
  padding: "10px $1",
  whiteSpace: "nowrap",
  textAlign: "left",
});

export const TD = styled("td", {
  background: vars.colors["surface-neutral-subdue"],
  color: "$text-neutral-base",
  fontSize: "$body",
  lettSpacing: "$bodyXS",
  lineHeight: "$headingS",
  padding: "10px $1",
  borderRight: "1px solid $outline-neutral-moreSubdue",

  variants: {
    isLastOfCategory: {
      true: {
        borderBottom: "1px solid $outline-neutral-moreSubdue",
      },
      false: {
        borerBottom: "1px solid transparent !important",
      },
    },
    align: {
      left: {
        textAlign: "left",
      },
      right: {
        textAlign: "right",
      },
    },
    highlighted: {
      true: {
        backgroundColor: "$surface-neutral-highlight",
      },
      false: {},
    },
    bright: {
      true: {
        backgroundColor: "$surface-neutral-moreHighlight",
      },
      false: {},
    },
    hasNext: {
      true: {
        borderBottom: "1px solid $outline-neutral-moreSubdue",
      },
      false: {},
    },
  },
});

export const MiniHeader = styled(Text, {
  color: "$text-neutral-base",
  fontWeight: "$bold",
  marginBottom: "$0h",
});

export const Block = styled("div", {
  display: "flex",
  flexDirection: "column",
  marginRight: "$4",

  "&:last-of-type": {
    marginRight: 0,
  },
});

export const BlockText = styled(Text, {
  color: "$text-neutral-highlight",
  fontSize: "$bodyM",
});
